<modal-wrapper class="modal" (closeModal)="closed.emit()">
	<ng-container modal-wrapper-additional-title> {{ data?.title }} </ng-container>

	<ng-container modal-wrapper-content>
		<form [formGroup]="form" class="form" [class.disabled]="editStatus.loading">
			<div class="form-row" *ngFor="let field of fields">
				<mat-form-field class="form-field" [class.disabled]="emptyFields[field.id]">
					<input matInput autocomplete="off" [placeholder]="field.name" [formControlName]="field.id" />
				</mat-form-field>

				<mat-checkbox
					class="checkbox"
					[checked]="emptyFields[field.id]"
					(click)="$event.stopPropagation()"
					(change)="selectEmptyCheckbox(field.id)"
				>
					Empty
				</mat-checkbox>
			</div>
		</form>
	</ng-container>

	<ng-container modal-wrapper-actions>
		<button mat-button class="button" [disabled]="editStatus.loading" (click)="closed.emit()">Cancel</button>
		<button
			mat-raised-button
			color="accent"
			class="button"
			[disabled]="formIsInvalid || editStatus.loading"
			(click)="saveForm()"
		>
			Save
		</button>
	</ng-container>
</modal-wrapper>
